export function handleError(error): string {
  let errorMessage = "";
  const err = error as { response?: { data?: { errors?: unknown } } };
  const errors = err.response?.data?.errors;
  if (errors) {
    if (typeof errors === "string") {
      errorMessage = errors;
    } else if (typeof errors === "object") {
      const firstKey = Object.keys(errors)[0];
      const firstError = Array.isArray(errors[firstKey]) ? errors[firstKey][0] : errors[firstKey];
      errorMessage = firstError;
    } else {
      errorMessage = "Operation failed.";
    }
  } else {
    errorMessage = "Operation failed.";
  }

  return errorMessage;
}
